import { Component } from 'preact'

export default class NotFound extends Component {
  render() {
    return (
      <div class="text-center mt-5 pt-5">
        <h2>404</h2>
        What are you doing?
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./pages/NotFound.js